/**
 *  @flow
 */

import React from 'react';
import { Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { Modal, Button } from '../../../components';

import CabinetForm from './form/CabinetForm';

const AddMasterDialog = ({
    trigger,
    open,
    onClose,
    onModalClose,
    handleSubmit,
    submitting,
    pristine,
    ...props
}) => (
    <Modal trigger={trigger} onClose={onModalClose} open={open}>
        <Modal.Header>
            <FormattedMessage
                id="pages.cabinets.AddCabinet.header"
                defaultMessage="New cabinet"
            />
        </Modal.Header>
        <Modal.Content>
            <CabinetForm
                {...props}
                handleSubmit={handleSubmit}
                submitting={submitting}
                pristine={pristine}
            />
        </Modal.Content>
        <Modal.Actions>
            <Button
                onClick={handleSubmit}
                disabled={submitting}
                loading={submitting}
                primary
            >
                <FormattedMessage
                    id="pages.cabinets.AddCabinet.save"
                    defaultMessage="Create"
                />
            </Button>
            <Button onClick={onModalClose} disabled={submitting} basic>
                <Icon name="remove" />
                <FormattedMessage
                    id="pages.cabinets.AddCabinet.cancel"
                    defaultMessage="Cancel"
                />
            </Button>
        </Modal.Actions>
    </Modal>
);

export default AddMasterDialog;
